<template>
  <div class="upload-file">
    <el-upload
      multiple
      :disabled="disabled"
      :action="file_system_url"
      :data="paramsData"
      :before-upload="handleBeforeUpload"
      :file-list="uploadFileList"
      :limit="limit"
      :on-error="handleUploadError"
      :on-exceed="handleExceed"
      :on-success="handleUploadSuccess"
      :show-file-list="false"
      :headers="headers"
      class="upload-file-uploader"
      ref="upload"
    >
      <!-- 上传按钮 -->
      <slot></slot>
      <!-- <el-button :disabled="disabled" type="primary">{{
        parentId == 0 ? "点击上传" : "上传文件"
      }}</el-button> -->
      <!-- 上传提示 -->
      <div class="el-upload__tip" slot="tip" v-if="showTip">
        <template v-if="limit">
          文件数量不超过 <b style="color: #c83636">{{ limit }}</b> 个
          ，</template
        >
        <template v-if="fileSize">
          大小不超过 <b style="color: #c83636">{{ fileSize }}MB</b> ，</template
        >
        <template v-if="fileType">
          格式为 <b style="color: #c83636">{{ fileType.join("/") }}</b>
        </template>
      </div>
    </el-upload>

    <!-- 文件列表 -->
    <transition-group
      class="upload-file-list el-upload-list el-upload-list--text"
      name="el-fade-in-linear"
      tag="ul"
    >
      <li
        class="el-upload-list__item ele-upload-list__item-content"
        v-for="(file, index) in uploadFileList"
        :key="index"
      >
        <el-link @click="download(file)" :underline="false" target="_blank">
          <div class="el-icon-document"> {{ file.name }} </div>
        </el-link>
        <div class="ele-upload-list__item-content-action">
          <el-link :underline="false" @click="handleDelete(index)" type="danger"
            >删除</el-link
          >
        </div>
      </li>
    </transition-group>
  </div>
</template>

<script>
import { loadByAlia } from "@/utils/format";
import { getToken } from "@/utils/auth";
import axios from "axios";
export default {
  name: "FileUpload",
  props: {
    // 值
    value: [String, Object, Array],
    // 数量限制
    limit: {
      type: Number,
      default: 5,
    },
    //
    disabled: {
      type: Boolean,
      default: false,
    },
    // 清空文件列表
    empty: {
      type: Boolean,
      default: true,
    },
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 1024,
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => [
        "doc",
        "docx",
        "xls",
        "xlsx",
        "ppt",
        "pptx",
        "txt",
        "pdf",
        "png",
        "jpg",
        "jpeg",
        // "gif",
        // "zip",
        // "rar",
        "mp4",
        // "m4a",
      ],
    },
    // // 编辑回显
    // fileList:{
    //   type: Array,
    //   default: () => ([])
    // },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
    },
    parentId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      number: 0,
      uploadList: [],
      baseUrl: process.env.VUE_APP_BASE_API,
      uploadFileUrl: process.env.VUE_APP_BASE_API + "/common/upload", // 上传的图片服务器地址
      headers: {
        Authorization: "Bearer " + getToken(),
      },
      uploadFileList: [], //  console.log(JSON.parse(sessionStorage.getItem('fileList')))
      //
      file_system_url: "",
      signature: {},
      paramsData: {},
    };
  },
  watch: {
    empty(val) {
      if (val == false) {
        this.uploadFileList = [];
      }
    },
    value: {
      handler(val) {
        if (val) {
          this.uploadFileList = val;
        }
      },
      deep: true,
      immediate: true,
    },
    // fileList: {
    //   handler(val) {
    //     console.log(val,'val')
    //     if (val) {
    //       val.forEach((item,index)=>{
    //         this.uploadFileList[index] ={
    //           ossOriUrl:item.url,
    //           fileName:item.name
    //         }
    //       })
    //     }
    //   },
    //   deep: true,
    //   immediate: true
    // },
  },
  computed: {
    // 是否显示提示
    showTip() {
      return this.isShowTip && (this.fileType || this.fileSize);
    },
  },
  created() {
    axios.post("https://www.icve.com.cn/project/Api/upload").then((res) => {
      if (res.data.code == 1) {
        this.file_system_url = res.data.file_system_url;
        this.signature = res.data.signature;
        this.paramsData = {
          key: this.signature.dir + "/" + this.signature.random + "/", //这里最好在后台处理好
          policy: this.signature.policy,
          OSSAccessKeyId: this.signature.accessid,
          success_action_status: "200", //让服务端返回200,不然，默认会返回204
          callback: this.signature.callback,
          signature: this.signature.signature,
          "x:space": this.signature.spaceName,
          "x:identity": this.signature.identity,
        };
      }
      // console.log('this.file_system_url',this.file_system_url)
    });
  },
  methods: {
    init(data) {
      this.uploadFileList = [];
      data.forEach((item, index) => {
        this.uploadFileList[index] = {
          ossOriUrl: item.url,
          fileName: item.name,
        };
      });
      this.$forceUpdate(); // 强制刷新
      console.log(this.uploadFileList);
    },
    download(file) {
      // window.open(url, "_system");
      loadByAlia(file.url, file.name);
      console.log(file,'点击的文件')
    },
    // 上传前校检格式和大小
    handleBeforeUpload(file) {
      console.log("file", file);
      this.paramsData.key = this.paramsData.key + file.name;
      // 校检文件类型
      if (this.fileType) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        const isTypeOk = this.fileType.some((type) => {
          // if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
        if (!isTypeOk) {
          this.$modal.msgError(
            `文件格式不正确, 请上传${this.fileType.join("/")}格式文件!`
          );
          return false;
        }
      }
      // 校检文件大小
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$modal.msgError(`上传文件大小不能超过 ${this.fileSize} MB!`);
          return false;
        }
      }
      this.$modal.loading("正在上传文件，请稍候...");
      this.number++;
      return true;
    },
    // 文件个数超出
    handleExceed() {
      this.$modal.msgError(`上传文件数量不能超过 ${this.limit} 个!`);
    },
    // 上传失败
    handleUploadError(err) {
      this.$modal.msgError("上传失败，请重试");
      this.$modal.closeLoading();
    },
    // 上传成功回调
    handleUploadSuccess(res, file) {
      // ossOriUrl 是访问地址
      res.id = "";
      res.status = "0";
      res.fileName = file.name;
      res.parentId = this.parentId;
      console.log(res);
      this.uploadFileList = [
        ...this.uploadFileList,
        { name: res.fileName, url: res.ossOriUrl, shortUrl: res.url },
      ];
      this.$emit("input", this.uploadFileList);
      this.$modal.closeLoading();
    },
    // 删除文件
    handleDelete(index) {
      this.uploadFileList.splice(index, 1);
      console.log(this.uploadFileList);
      this.$emit("input", this.uploadFileList);
    },
    // 获取文件名称
    getFileName(name) {
      if (name.lastIndexOf("/") > -1) {
        return name.slice(name.lastIndexOf("/") + 1);
      } else {
        return "";
      }
    },
    // 对象转成指定字符串分隔
    listToString(list, separator) {
      let strs = "";
      separator = separator || ",";
      for (let i in list) {
        strs += list[i].url + separator;
      }
      return strs != "" ? strs.substr(0, strs.length - 1) : "";
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-link--inner{
  display: flex;
  align-items: center;
  width: 100%;
}
::v-deep .ele-upload-list__item-content-action{
  flex-shrink: 0;
}
::v-deep .el-link{
  width: 80%;
  flex-shrink: 0;
  justify-content: initial;
}
::v-deep .el-icon-document{
  width: 100%;
  height: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.upload-file-uploader {
  margin-bottom: 5px;
}
.upload-file-list .el-upload-list__item {
  border: 1px solid #e6e6e6;
  line-height: 2;
  margin-bottom: 10px;
  position: relative;
}
.upload-file-list .ele-upload-list__item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: inherit;
}
.ele-upload-list__item-content-action .el-link {
  margin-right: 10px;
}
</style>
